import { useQuery } from '@apollo/client';
import { GET_ADMIN_ACTIVITY } from '../graphql/Queries';

export interface AdminActivityData {
  adminActivity: {
    success: boolean;
    errors?: string[];
    dodRetentionPct: number | null;
    activeStreakers: number;
    activeUsers: number;
    usersCompletedLast7Days: number;
  };
}

export function useAdminActivity() {
  return useQuery<AdminActivityData>(GET_ADMIN_ACTIVITY);
}
